module.exports = __webpack_public_path__ + "static/8-be27c84ca4b8e3a684f9901d52e0cd57.png";